/* @ngInject */
function featureReleaseNotificationsService (CONSTANTS, ConnectorWebService, Utils) {
  const service = {
    createUserNotificationOption,
    getUserNotificationOption
  }
  return service

  function createUserNotificationOption (featureSlug) {
    if (!featureSlug) {
      throw new Error('featureSlug cannot be null')
    }

    return ConnectorWebService.post(CONSTANTS.URL_FEATURE_RELEASE_NOTIFICATIONS, { featureSlug })
  }

  function getUserNotificationOption (featureSlug) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_FEATURE_RELEASE_NOTIFICATIONS_SLUG, [featureSlug])
    return ConnectorWebService.get(url)
  }
}

export { featureReleaseNotificationsService }
